"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTransformResponsePipeline = void 0;

var _fetch = require("../helpers/fetch");

var _util = require("../helpers/util");

var defaultTransformResponsePipeline = [function (res) {
  return (0, _fetch.parseResponse)(res).then(function (body) {
    var transformedResponse = {
      body: body,
      code: res.status
    }; // Add support for Content-Range parsing when a partial http code is used

    var isPartialContent = res.status === 206;

    if (isPartialContent) {
      transformedResponse.contentRange = (0, _util.parseContentRangeHeader)(res.headers.get('Content-Range'));
    }

    return transformedResponse;
  });
}]; // eslint-disable-line

exports.defaultTransformResponsePipeline = defaultTransformResponsePipeline;